import React from 'react'
import footerimg from '../../assets/imges/Whitefriar-logo-light-1-2048x396-1-1.png'
import './footer.css'

function Footer() {
  return (
    <footer className=''>
      <div className='inner-footer custome_container'>
        <div className='content_wrapper'>
          <img src={footerimg} className='footerimg'></img>
          <h2 className='footer-title text-start'>C-Suite, executives, founders, and companies use Whitefriar to build and manage their online presence.</h2>
          <p>© 2025 Whitefriar.com. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  )
}

export default Footer